const MYDATA_DRAFT_KEY = 'mydata_draft_v1';

const COLLECT_ATTEMPT_FIELDS = [
  'collectJobId',
  'collectJobStatus',
  'collectJobStep',
  'collectJobProgressPercent',
  'collectJobUpdatedAt',
  'collectJobErrorCode',
  'collectJobErrorMessage',
  'collectJobFinalizing',
  'fetchStartedAt',
];

export const getMyDataDraft = () => {
  try {
    const raw = window.sessionStorage.getItem(MYDATA_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setMyDataDraft = (nextDraft) => {
  try {
    window.sessionStorage.setItem(MYDATA_DRAFT_KEY, JSON.stringify(nextDraft || {}));
  } catch {
    // ignore
  }
};

export const patchMyDataDraft = (partial) => {
  const prev = getMyDataDraft() || {};
  const next = { ...prev, ...(partial || {}) };
  setMyDataDraft(next);
  return next;
};

export const startMyDataAuthenticationAttempt = (partial) => {
  const next = { ...(getMyDataDraft() || {}), ...(partial || {}) };
  COLLECT_ATTEMPT_FIELDS.forEach((field) => {
    delete next[field];
  });
  setMyDataDraft(next);
  return next;
};

export const clearMyDataDraft = () => {
  try {
    window.sessionStorage.removeItem(MYDATA_DRAFT_KEY);
  } catch {
    // ignore
  }
};
